"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _toMoneyFormat = _interopRequireDefault(require("../../utils/toMoneyFormat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 4px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 0px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["  \n  font-size: 12px;\n  line-height: 20px;\n  \n  color: ", ";\n  white-space: nowrap;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin-left: 8px;\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 21px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 32px;\n    line-height: 40px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color : ", ";\n    font-size: 14px;\n    line-height: 22px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SpendingBlockStyled = _styledComponents.default.div(_templateObject());

var SpedingBlockDescriptionStyled = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.colorGray;
});

var SpendingBlockSummStyled = _styledComponents.default.div(_templateObject3());

var SpendingBlockCurrencyStyled = _styledComponents.default.span(_templateObject4());

var SpendingBlockSubitemStyled = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.theme.colorGray;
});

var SpendingBlockFirstSubitemStyled = (0, _styledComponents.default)(SpendingBlockSubitemStyled)(_templateObject6());
var SpendingBlockSecondSubitemStyled = (0, _styledComponents.default)(SpendingBlockSubitemStyled)(_templateObject7());

var SpendingBlockValueResult = _styledComponents.default.b(_templateObject8());

var SpendingBlock = function SpendingBlock(props) {
  var description = props.description,
      summ = props.summ,
      firstSubitem = props.firstSubitem,
      secondSubitem = props.secondSubitem,
      subDesc = props.subDesc;
  return /*#__PURE__*/_react.default.createElement(SpendingBlockStyled, null, /*#__PURE__*/_react.default.createElement(SpedingBlockDescriptionStyled, null, description, subDesc && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, subDesc)), /*#__PURE__*/_react.default.createElement(SpendingBlockSummStyled, null, (0, _toMoneyFormat.default)(summ), /*#__PURE__*/_react.default.createElement(SpendingBlockCurrencyStyled, null, "\u0440\u0443\u0431.")), /*#__PURE__*/_react.default.createElement(SpendingBlockFirstSubitemStyled, null, firstSubitem.label, /*#__PURE__*/_react.default.createElement(SpendingBlockValueResult, null, (0, _toMoneyFormat.default)(firstSubitem.summ), " \u0440\u0443\u0431.")), /*#__PURE__*/_react.default.createElement(SpendingBlockSecondSubitemStyled, null, secondSubitem.label, /*#__PURE__*/_react.default.createElement(SpendingBlockValueResult, null, (0, _toMoneyFormat.default)(secondSubitem.summ), " \u0440\u0443\u0431.")));
};

SpendingBlock.propTypes = {
  description: _propTypes.default.string.isRequired,
  subDesc: _propTypes.default.string,
  summ: _propTypes.default.number.isRequired,
  firstSubitem: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    summ: _propTypes.default.number.isRequired
  }).isRequired,
  secondSubitem: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    summ: _propTypes.default.number.isRequired
  }).isRequired
};
var _default = SpendingBlock;
exports.default = _default;